module.exports = __webpack_public_path__ + "img/vpc18.47dc801.png";